import { Address } from '@portal/models/address';
import { SuggestionsMapperService } from './base/suggestions-mapper.service';
import type { DadataAddress, DadataParty } from './interfaces';
import type { NoMultiLangCompanyCreateRequest } from './suggestion-iterfaces';

export class DadataSuggestionsMapperService extends SuggestionsMapperService<DadataParty, DadataAddress> {
  mapCompany(data: DadataParty | null): NoMultiLangCompanyCreateRequest | null {
    if (!data) {
      return null;
    }

    const [lastName, firstName, middleName] = data.management?.name.split(' ') || [];

    const res: NoMultiLangCompanyCreateRequest = {
      fullName: data.name.full,
      shortName: data.name.short,
      inn: data.inn,
      manager: {
        firstName,
        lastName,
        middleName,
      },
      legalAddress: this.mapAddress(data.address.data),
      additionalFields: this.mapToAdditionalFields(data),
    };

    return res;
  }

  mapAddress(data: DadataAddress): Address | null {
    if (!data) {
      return null;
    }

    return {
      title: data.source,
      countryWithId: {
        id: 1,
        country: {
          iso2: data.country_iso_code,
          title: data.country,
        },
      },
      region: {
        id: +data.region_kladr_id,
        title: data.region,
      },
      city: data.city,
      district: data.city_district,
      addressLine: data.source,
      postalCode: data.postal_code,
    };
  }

  private mapToAdditionalFields(data: DadataParty): Record<string, object> {
    return Object.entries(data ?? {})
      .filter(([_, value]) => {
        return !Array.isArray(value) && (typeof value === 'string' || typeof value === 'number');
      })
      .reduce(
        (acc, [key, value]) => {
          acc[key] = value;
          return acc;
        },
        {} as Record<string, object>,
      );
  }
}
